import styled from 'styled-components';
import colors from 'styles/colors';
import media from 'styles/media';
import fonts from 'styles/fonts';

export const CardImg = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 5px;
  transition: all 0.1s cubic-bezier(0, 0, 0, 0);
  overflow: hidden;
  & span {
    transition: all 0.1s cubic-bezier(0, 0, 0, 0);
  }
`;

export const CardWrapper = styled.div`
  transition: opacity 0.2s cubic-bezier(0, 0, 0, 0);
  &.disabled {
    opacity: 0.25;
    pointer-events: none;
  }
`;

export const Card = styled.button`
  cursor: pointer;
  background-color: ${colors.functional.grey};
  height: 100px;
  width: 100%;

  -webkit-tap-highlight-color: transparent;
  display: flex;
  opacity: 0;

  border-radius: 5px;
  background: linear-gradient(
    0deg,
    rgba(155, 161, 187, 0.4),
    rgba(155, 161, 187, 1)
  );
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: -6px;
    left: -6px;
    height: calc(100% + 12px);
    width: calc(100% + 12px);
    border: 3px solid ${colors.primary.deepCove};
    pointer-events: none;
    border-radius: 8px;
    transform: scale(0.98);
    opacity: 0;
    transition: transform 0.1s ease, opacity 0.1s ease;
  }

  .selected & {
    &:before {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:hover ${CardImg} span {
    transform: scale(1.05);
    transition: all 0.1s ease;
  }

  ${media.medium`
    height: 100px;
    width: 100%;
    &:hover ${CardImg} span {
      transform: scale(1);
    }
  `}

  ${media.small`
    height: 100px;
  `}

  .storybook & {
    opacity: 1 !important;
  }
`;

export const Label = styled.h3`
  position: absolute;
  color: ${colors.primary.ice};
  padding: 10px;
  font-family: ${fonts.secondary.bold};
  width: 100%;
  height: 100%;

  text-align: left;
  align-items: stretch;
  justify-content: flex-end;
  & div {
    position: absolute;
    bottom: 5px;
    left: 10px;
    font-size: 10px;
    line-height: 12px;
    margin-bottom: 10px;
    & span {
      text-transform: uppercase;
      font-size: 20px;
      line-height: 20px;
      display: block;
    }
  }
`;
export const SectionTitle = styled.h2`
  color: ${colors.functional.black};
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 15px;
`;

export const Grid = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  min-height: 40vh;
  ${media.medium`
    gap: 15px;
    `}

  ${media.small`
    gap: 15px;
    `}
`;

export const Placeholder = styled.div`
  background: ${colors.secondary.deepCoveVeryLight};
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 5px;
`;

export const ImageGradient = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 60.42%,
    rgba(0, 0, 0, 0.7) 89.58%
  );
`;
